module.exports = __webpack_public_path__ + "img/beer.43833db3.svg";